export default {"src":"/_next/static/media/eth.f078ba17.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};